import { create } from 'zustand'

interface State {
  visible: boolean
}

interface Action {
  changeVisible: ({ visible }: { visible: State['visible'] }) => void
}

export const sidebarStore = create<State & Action>((set) => ({
  visible: false,
  changeVisible: ({ visible }) => set(() => ({ visible: visible })),
}))
